import React from 'react'
// libs
import styled from 'styled-components'
// components
import CircularProgress from '@mui/material/CircularProgress'
// themes
import { colors } from 'themes'

const Wrapper = styled.div<{ height: string }>`
  align-items: center;
  display: flex;
  height: ${({ height }) => height};
  justify-content: center;
  width: 100%;
`

const styles = {
  progress: { color: colors.purple300 }
}

interface Props {
  height?: string
  isLoading: boolean
}

const LoaderWithOverlay: React.FC<Props> = ({ isLoading, height = '100vh' }) => {
  if (!isLoading) return null

  return (
    <Wrapper height={height}>
      <CircularProgress style={styles.progress} />
    </Wrapper>
  )
}

export default LoaderWithOverlay
